import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    addCommas,
    addFromColumn,
    convertStartEndDatesForFile,
    sortCurrency,
    toCurrency,
} from '../shared/functions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from "../shared/tableFunctions";
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import FlatButton from "material-ui/FlatButton";
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import TableIcon from 'material-ui/svg-icons/communication/location-on';

/**
 * Class for displaying Sales Summary by Location in a single table
 *
 */
class SalesSummaryReportLocationTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            summaryList: [],
            summaryTableData: [],
            summaryTableHeaders: [
                {label: 'Location ID', key: 'location_id'},
                {label: 'Location Name', key: 'location_name'},
                {label: 'City', key: 'city'},
                {label: 'State', key: 'state'},
                {label: 'DBA', key: 'dba_name'},
                {label: 'District', key: 'district_name'},
                {label: 'Average Cash', key: 'average_cash'},
                {label: 'Average VIP', key: 'average_vip'},
                {label: 'Average Non-VIP', key: 'average_non_vip'},
                {label: 'Credit Card Payments', key: 'count_cc'},
                {label: 'Cash Payments', key: 'count_cash'},
                {label: 'Credit Card Total', key: 'total_cc'},
                {label: 'Cash Total', key: 'total_cash'},
                {label: 'Total Gross Sales', key: 'total_sales'},
                {label: 'Total Gross Returns', key: 'total_returns'},
                {label: 'Total Net', key: 'total_net'},
            ],
            message: null,
            summaryComplete: false,
        };
        this.handleExportClick = this.handleExportClick.bind(this);
        this.handleSortOrFilterChange = this.handleSortOrFilterChange.bind(this);
    }

    componentWillMount() {
        this.processData(this.props.listData);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.listData !== this.props.listData) {
            this.setState({
                summaryList: [],
                summaryComplete: false,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.listData !== this.props.listData) {
            this.processData(this.props.listData);
        }
    }

    /* Data Processing ------------------------------ */

    /**
     * Arrange data for use by table
     *
     * @param listData
     */
    processData(listData) {

        const emptyCurrency = toCurrency(0);
        let summaryList = [];

        if (listData) {
            let listLength = listData.length;
            for (let i = 0; i < listLength; i++) {
                let result = listData[i];
                let location = result.column_name.hits.hits[0]._source.rxtxMsg.payload.location;
                let averageCash = 0;
                let averageNonVIP = 0;
                let averageVIP = 0;
                let countCash = 0;
                let countCredit = 0;
                let totalCredit = 0;
                let totalCash = 0;
                let totalReturns = 0;
                let totalSales = 0;
                let totalNet = 0;
                const payments = result.payments;
                if (payments && payments.cash_filter) {
                    if (payments.cash_filter.cash_avg && payments.cash_filter.cash_avg.value) {
                        averageCash = payments.cash_filter.cash_avg.value;
                    }
                    if (payments.cash_filter.cash_count) {
                        countCash = payments.cash_filter.cash_count.value;
                    }
                    if (payments.cash_filter.cash_total) {
                        totalCash = payments.cash_filter.cash_total.value;
                    }
                }
                if (payments && payments.credit_card_filter) {
                    if (payments.credit_card_filter.credit_card_count) {
                        countCredit = payments.credit_card_filter.credit_card_count.value;
                    }
                    if (payments.credit_card_filter.credit_card_total) {
                        totalCredit = payments.credit_card_filter.credit_card_total.value;
                    }
                }
                if (result.avg_non_vip_filter && result.avg_non_vip_filter.payments && result.avg_non_vip_filter.payments.non_vip_avg) {
                    averageNonVIP = result.avg_non_vip_filter.payments.non_vip_avg.value;
                }
                if (result.avg_vip_filter && result.avg_vip_filter.payments && result.avg_vip_filter.payments.vip_avg) {
                    averageVIP = result.avg_vip_filter.payments.vip_avg.value;
                }
                if (result.credits && result.credits.cash_credit_filter && result.credits.cash_credit_filter.credit_total) {
                    totalReturns = result.credits.cash_credit_filter.credit_total.value;
                }
                if (payments && payments.cash_credit_filter && payments.cash_credit_filter.payment_total) {
                    totalSales = payments.cash_credit_filter.payment_total.value;
                }
                if(result.total_net) {
                    totalNet = result.total_net.value;
                }
                // totalNet = (((totalSales) ? totalSales : 0) + ((totalReturns) ? totalReturns : 0));

                const row = {
                    city: (location.city) ? location.city : '(None)',
                    dba_name: (location.dba && location.dba.name) ? location.dba.name : '(None)',
                    district_name: (location.district && location.district.name) ? location.district.name : '(None)',
                    location_id: (location.id) ? location.id : '----',
                    location_name: (location.name) ? location.name : '(None)',
                    state: (location.state) ? location.state : '--',
                    average_cash: (averageCash) ? (toCurrency(averageCash / 100)) : emptyCurrency,
                    average_non_vip: (averageNonVIP) ? (toCurrency(averageNonVIP / 100)) : emptyCurrency,
                    average_vip: (averageVIP) ? (toCurrency(averageVIP / 100)) : emptyCurrency,
                    count_cash: (countCash) ? addCommas(countCash) : 0,
                    count_cc: (countCredit) ? addCommas(countCredit) : 0,
                    total_cash: (totalCash) ? (toCurrency(totalCash / 100)) : emptyCurrency,
                    total_cc: (totalCredit) ? (toCurrency(totalCredit / 100)) : emptyCurrency,
                    total_returns: (totalReturns) ? (toCurrency(totalReturns / 100)) : emptyCurrency,
                    total_sales: (totalSales) ? (toCurrency(totalSales / 100)) : emptyCurrency,
                    total_net: (totalNet) ? (toCurrency(totalNet / 100)) : emptyCurrency,
                };
                summaryList.push(row);
            }
        }

        // Finalize table data
        this.setState({
            summaryList: summaryList,
            summaryTableData: summaryList,
            summaryComplete: true,
        });
        this.props.onSummaryComplete('location', true);
    }

    /* Table Building ------------------------------ */

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortOrFilterChange(event, table) {
        const tableData = getTableState(table);
        if (tableData && tableData.length > 0) {
            this.setState({
                summaryTableData: tableData
            });
        }
    }

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    /* Table Display ------------------------------ */

    render() {

        const {
            dataIsFiltered,
            endDate,
            startDate,
            system,
        } = this.props;

        const {
            summaryList,
            summaryTableData,
            summaryTableHeaders,
            summaryComplete,
        } = this.state;

        const dateString = convertStartEndDatesForFile(startDate, endDate);
        const isFilteredString = (dataIsFiltered) ? '-filtered' : '';
        const defaultSort = setDefaultTableSort('location_id');

        // ReactTable headers and columns for Table
        const tableColumns = [
            {
                Header: 'Location',
                columns: [
                    {
                        Header: 'Store',
                        accessor: 'location_id',
                        style: tableStyles.tdMax
                    },
                    {
                        Header: 'Location Name',
                        accessor: 'location_name',
                    },
                    {
                        Header: 'City',
                        accessor: 'city',
                    },
                    {
                        Header: 'State',
                        accessor: 'state',
                        style: tableStyles.tdMax
                    },
                    {
                        Header: 'DBA',
                        accessor: 'dba_name',
                    },
                    {
                        Header: 'District',
                        accessor: 'district_name',
                        headerStyle: tableStyles.thLast,
                    }
                ]
            },
            {
                Header: 'Averages',
                columns: [
                    {
                        Header: () => (<span>Average<br/>Cash</span>),
                        accessor: 'average_cash',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'average_cash') / this.state.summaryList.length)}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Average<br/>VIP</span>),
                        accessor: 'average_vip',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'average_vip') / this.state.summaryList.length)}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Average<br/>Non-VIP</span>),
                        accessor: 'average_non_vip',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        headerStyle: tableStyles.thLast,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'average_non_vip') / this.state.summaryList.length)}
                            </span>
                        )
                    }
                ]
            },
            {
                Header: 'Sales and Returns',
                columns: [
                    {
                        Header: () => (<span>Credit Card<br/>Payments</span>),
                        accessor: 'count_cc',
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addCommas(addFromColumn(summaryTableData, 'count_cc'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Cash<br/>Payments</span>),
                        accessor: 'count_cash',
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addCommas(addFromColumn(summaryTableData, 'count_cash'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Credit Card<br/>Total</span>),
                        accessor: 'total_cc',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'total_cc'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Cash<br/>Total</span>),
                        accessor: 'total_cash',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'total_cash'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Total Gross<br/>Sales</span>),
                        accessor: 'total_sales',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'total_sales'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Total Gross<br/>Returns</span>),
                        accessor: 'total_returns',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'total_returns'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Total<br/>Net</span>),
                        accessor: 'total_net',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        headerStyle: tableStyles.thLast,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'total_net'))}
                            </span>
                        )
                    }
                ]
            }
        ];

        return (
            <div>
                {summaryComplete &&
                <div className="reports-table-container">

                    {/* Table Header: Sales Summary */}
                    <div className="reports-table-title table-table-header">
                        <div className="btn-report-container table-header-button-container">
                            {/* Export Sales Summary */}
                            <FlatButton
                                primary
                                type="button"
                                label=""
                                style={commonStyles.headerButton}
                            >
                                <ExportIcon style={commonStyles.headerButtonIcon}/>
                                <CSVLink
                                    data={summaryTableData}
                                    headers={summaryTableHeaders}
                                    filename={'Sales-Summary-Location-' + system + '-' + dateString + isFilteredString + '.csv'}
                                    onClick={(e) => this.handleExportClick(e)}
                                    target="_blank"
                                    style={commonStyles.headerButtonLink}
                                >
                                    Export Sales Summary
                                </CSVLink>
                            </FlatButton>
                        </div>
                        <h3 className="table-table-header-title">
                            <TableIcon style={commonStyles.summaryIconSmall}/>
                            <span>Sales Summary</span>
                        </h3>
                    </div>

                    {/* Table: Sales Summary by Location */}
                    <ReactTable
                        key="table-sales-summary-location"
                        data={summaryList}
                        columns={tableColumns}
                        defaultPageSize={5}
                        showPagination={true}
                        defaultSorted={defaultSort}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => this.handleSortOrFilterChange(e, this.summaryLocationReactTable)}
                        onFilteredChange={(e) => this.handleSortOrFilterChange(e, this.summaryLocationReactTable)}
                        ref={(r) => this.summaryLocationReactTable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped overflow no-print"
                    />
                    <ReactTable
                        key="table-sales-summary-location-print"
                        data={summaryTableData}
                        columns={tableColumns}
                        defaultPageSize={10000}
                        showPagination={false}
                        defaultSorted={defaultSort}
                        filterable
                        resizable={false}
                        minRows={1}
                        className="print-only"
                    />
                </div>
                }
            </div>
        )
    }
}

SalesSummaryReportLocationTable.propTypes = {
    addField: PropTypes.bool,
    dataIsFiltered: PropTypes.bool,
    endDate: PropTypes.string,
    listData: PropTypes.array,
    onDisplayMessage: PropTypes.func,
    onSummaryComplete: PropTypes.func,
    startDate: PropTypes.string,
    system: PropTypes.string,
};

SalesSummaryReportLocationTable.defaultProps = {
    addField: true,
    dataIsFiltered: false,
    endDate: null,
    startDate: null,
};

export default SalesSummaryReportLocationTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/SalesSummaryReportLocationTable.js